import {
  AssetVerification,
  CreditAgreement,
  Util,
} from '@finley-technologies/finley-types';

// these are mapped from AssetVerification.AssetVerificationOutput.VerificationStatus
export const LenderVerificationStatusValues = [
  'passed',
  'failed',
  'untested',
  'finleyReview',
] as const;

export type LenderVerificationStatus = typeof LenderVerificationStatusValues[number];

export type IDWithTimeStamp = {
  id: string;
  timestamp: number;
};

export type AssetVerificationReceivable = Omit<
  AssetVerification.AssetVerificationOutput.Receivable,
  'documentations'
> & {
  rawIdsWithTimestamps: IDWithTimeStamp[];
  lenderVerificationStatus: LenderVerificationStatus;
};

export type AssetVerificationSummaryCounts = {
  [key in LenderVerificationStatus]: number;
};

// receivables gropued by status.
export type AssetVerificationStatusReceivables = {
  [key in LenderVerificationStatus]: AssetVerificationReceivable[];
};

export type BaseFieldConfigMap = Record<
  string,
  CreditAgreement.DataTapeField.BaseConfig
>;

export type AssetVerificationReceivableContainer = {
  baseFieldConfigsMap: BaseFieldConfigMap;
  summaryCounts: AssetVerificationSummaryCounts;
  statusReceivables: AssetVerificationStatusReceivables;
};

export type AssetVerificationEditorProps = {
  receivableDocumentationRawId: string;
  creditFacilityId: string;
  reportingDate: Util.FullDateStr;
  fileVersion: number;
  artifactDocumentId: string;
  finleyReceivableId: string;
};

export type EditAssetVerification = (
  props: AssetVerificationEditorProps,
) => void;
